import { useFormikContext } from 'formik'
import { AssetConfiguration } from '../../../types'

export const useAssetConfigurationForm = () => {
  const context = useFormikContext<AssetConfiguration>()
  return context
}
